import { ReduxSocket } from '@hlibs/react/redux';
import AppConfig from '@app/config';
import * as Crypto from '@hlibs/crypto';
import { Utils } from '@hlibs/index';
import Handlers from './handler';
import Config from './config';

const socketAuthKey = Config.AUTH_KEY;

const maxHistoryCount = 100;

const socketHistory = [];

class Socket extends ReduxSocket
{
    static create = (name, address, token, config = { reconnect: true, transports: ['websocket'] }) => new Socket(name, address, token, config);

    static connect = (params = { id: 'id', email: '' }) =>
    {
        const token = Crypto.AES.encrypt(JSON.stringify(params), socketAuthKey);

        super.connect(AppConfig.SOCKET.url, token, { reconnect: true, transports: ['websocket'] });
    }
};

const onConnect = (socket) =>
{
    socket.on('socket_message', (recvData) =>
    {
        try
        {
            if(recvData)
            {
                const { data } = JSON.parse(recvData);

                if(data?.id && Utils.findInArray(data?.id, socketHistory) == false)
                {
                    socketHistory.push(data?.id);

                    if(socketHistory.length > maxHistoryCount)
                    {
                        socketHistory.splice(0, maxHistoryCount / 10);
                    }

                    Handlers.OnKycResponse.invoke(data);
                }
            }    
        }
        catch(e)
        {
//                Debug.error(e);
        }
    });
};

const reduxModule = Socket.create("Socket", null, null, null, onConnect);

export default reduxModule;
